import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import {
  StyledEngineProvider,
  ThemeProvider as MuiThemeProvider,
} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as StyledCompThemeProvider } from 'styled-components';
import { SnackbarProvider } from 'notistack';

import {
  useBeforeUnload,
  useBusinessLogic,
  useCustomerAccount,
  usePortfolio,
  usePositions,
  useTradingAccounts,
} from '@trader/hooks';
import { useMst } from '@trader/store';
import { RenderRoutes } from '@trader/navigation';
import { SmartLookService } from '@trader/services';
import { NotificationContainer } from '@trader/containers';
import { EThemes, GlobalStyles, getTheme } from '@trader/themes';

import { routes } from '../core/navigation';
import { darkTheme, lightTheme } from '../themes';

export const App: React.FC = observer(() => {
  const store = useMst();
  const { applyCondition } = useBusinessLogic('second_case');

  useBeforeUnload();
  usePortfolio();
  usePositions();
  useTradingAccounts();
  useCustomerAccount();

  useEffect(() => {
    SmartLookService.init();
    applyCondition();
  }, []);

  const themeMode = store.app.themeMode;
  const themeOptions = themeMode === EThemes.Dark ? darkTheme : lightTheme;
  const theme = getTheme(themeMode, themeOptions);

  return (
    <MuiThemeProvider theme={theme}>
      <StyledCompThemeProvider theme={theme}>
        <StyledEngineProvider injectFirst>
          <CssBaseline />
          <GlobalStyles />
          <SnackbarProvider maxSnack={4}>
            <RenderRoutes routes={routes} />
            <NotificationContainer />
          </SnackbarProvider>
        </StyledEngineProvider>
      </StyledCompThemeProvider>
    </MuiThemeProvider>
  );
});
